export default "__VITE_ASSET__BTrhylzd__"